import { MarketplaceSelect } from 'components/filter/input/MarketplaceSelect';
import { BrandSelect } from 'components/filter/input/BrandSelect';
import { CountrySelect } from 'components/filter/input/CountrySelect';
import { FilteredContent } from 'pages/ArticleVisibility/components/FilteredContent';
import { ArticleVisibilityDatePicker } from 'components/filter/modules/article-visibility';
import { FilterDialogButton } from 'components/filter/advancedFilter';
import { PageHeader } from 'components/Layout/PageContainer';

export function ArticleVisibility() {
  return (
    <div className="max-w-none insights-pro">
      <PageHeader
        topRightComponent={
          <>
            <ArticleVisibilityDatePicker
              caption="datepicker.type.creation"
              emptyMessage="datepicker.empty.no.filtering"
            />
          </>
        }
      >
        <CountrySelect />
        <BrandSelect />
        <MarketplaceSelect />
        <FilterDialogButton module="articlevisibility" />
      </PageHeader>
      <div className="px-10">
        <FilteredContent />
      </div>
    </div>
  );
}
